<template>
  <div class="com-frame">
    <div class="left-frame">

      <ul v-for="(menuItem,index) in dataList" class="h-menu menu-custom h-menu-mode-vertical">
        <li class="h-menu-li h-menu-first-level" @click="menuClick(menuItem)">
          <div :class="'h-menu-show' + ((selectedMenu.key==menuItem.key)?' h-menu-li-selected':'')">
            <span class="h-menu-show-icon">
              {{ index +1 }} 、<i :class="menuItem.icon"></i>
            </span>
            <Tooltip :content="menuItem.title" placement="top-start">
            <span class="h-menu-show-desc" >{{ menuItem.title }}</span>
            </Tooltip>
          </div>
        </li>
      </ul>

    </div>
    <div class="right-frame">

      <img v-if="selectedMenu.type=='img'" :src="selectedMenu.url+'#navpanes=0'" title="" style="width:100%;height:100%;" />
      <iframe v-else :src="selectedMenu.url+'#navpanes=0'" title="" style="width:100%;height:100%;" />

    </div>

  </div>
</template>

<script>
  export default {
    name: "VoucherAttachmentList",
    props: {
      billList: Array
    },
    data(){
      return{
        dataList: [],
        selectedMenu: {
          title: '',
          key: '',
          type: 'pdf',
          icon: 'fa fa-file-pdf-o',
          url:''
        },
      }
    },
    created() {
      this.loadList();
    },
    methods: {
      loadList(){
        console.log(this.billList)
        for (let i = 0; i < this.billList.length; i++) {
          let item = this.billList[i];
          let menu = {
            title: '',
            key: '',
            type: 'pdf',
            icon: 'fa fa-file-pdf-o',
            url:''
          };
          menu.title = item.name;
          menu.key = item.uid;
          switch(item.type){
            case "application/pdf":
              menu.icon = 'fa fa-file-pdf-o';
              menu.type = 'pdf';
              break;
            case "image/jpeg":
            case "image/png":
            case "image/bmp":
            case "image/gif":
              menu.icon = 'fa fa-file-image-o';
              menu.type = 'img';
              break;
            case "text/plain":
              menu.icon = 'fa fa-file-text-o';
              menu.type = 'txt';
              break;
            case "application/msword":
            case "application/vnd.ms-excel":
              menu.icon = 'fa fa-file-excel-o';
              menu.type = 'excel';
              break;
            case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
            case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
              menu.icon = 'fa fa-file-word-o';
              menu.type = 'word';
              break;
            case "application/vnd.ms-powerpoint":
            case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
              menu.icon = 'fa fa-file-powerpoint-o';
              menu.type = 'ppt';
              break;
            case "application/x-zip-compressed":
              menu.icon = 'fa fa-file-zip-o';
              menu.type = 'zip';
              break;
            default:
              menu.icon = 'fa fa-file-pdf-o';
              menu.type = 'pdf';
          }

          if(item.isExternalLink){
            menu.url = item.url
          }else{
            menu.url = '/api'+item.url+'?name='+item.name
          }

          if(i==0){
            this.selectedMenu = menu;
          }

          this.dataList.push(menu)
        }
      },
      menuClick(data){
        this.selectedMenu = data;

      },
    },
  }
</script>

<!--<script setup>-->

<!--  import voucher from "@/api/voucher";-->
<!--  import {h, ref} from "vue";-->
<!--  import {confirm, message} from "heyui.ext";-->
<!--  import {layer} from "@layui/layer-vue";-->
<!--  const props = defineProps(['billList']);-->
<!--  const loading = ref(false)-->
<!--  const dataList = ref([])-->
<!--  const emits = defineEmits(['close', 'success']);-->
<!--  const pdfUrl = ref();-->
<!--  const fileMenu = ref();-->

<!--  const loadList = () => {-->
<!--    loading.value = true;-->
<!--    dataList.value =  [-->

<!--    ]-->
<!--    // voucher.tpl().then(({data}) => {-->
<!--    //   dataList.value = data;-->
<!--    //-->
<!--    // }).finally((() => loading.value = false))-->

<!--    for (let i = 0; i < props.billList.length; i++) {-->
<!--      let item = props.billList[i];-->
<!--      let menu = {-->
<!--        title: '',-->
<!--        key: '',-->
<!--        icon: 'fa fa-file-pdf-o',-->
<!--        url:''-->
<!--      };-->
<!--      menu.title = item.name;-->
<!--      menu.key = item.uid;-->
<!--      switch(item.type){-->
<!--        case "application/pdf":-->
<!--          menu.icon = 'fa fa-file-pdf-o';-->
<!--      }-->

<!--      if(item.isExternalLink){-->
<!--        menu.url = item.url-->
<!--      }else{-->
<!--        menu.url = '/api'+item.url+'?name='+item.name-->
<!--      }-->

<!--      if(i==0){-->
<!--        pdfUrl.value = menu.url;-->
<!--      }-->

<!--      dataList.value.push(menu)-->
<!--    }-->
<!--  }-->

<!--  const menuClick = (data) => {-->
<!--    pdfUrl.value = data.url;-->
<!--  }-->
<!--  loadList();-->

<!--</script>-->

<style lang="less" >

.menu-custom {
  .h-menu {
    &-show {
      &:hover {
        // background: @yellow-color;
        color: @blue-color;;
      }
    }
    &-li {
      &-selected {
        font-weight: bold;
        // background: @yellow-color;
        color: @blue-color;;
      }
    }
  }
}
.com-frame {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
}
.com-frame .left-frame {
  position: absolute;
  z-index: 2;
  overflow: auto;
  bottom: 0;
  top: 0;
  width: 280px;
  padding: 10px 0 10px;
  line-height: 2.5;
  border-right:1px solid #f0f0f0;
}
.com-frame .right-frame {
  position: absolute;
  left: 280px;
  right: 0;
  bottom: 0;
  top: 0;
  padding: 0 0 5px 0;
  overflow: auto;
  z-index: 1;
}

</style>
